export async function handleFileDownload(
  apiUrl: string,
  token: string,
  documentName: string
): Promise<HTMLAnchorElement> {
  const blob = await fetch(apiUrl, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`
    }
  }).then((res) => res.blob());

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');

  a.href = url;
  a.download = documentName;
  a.setAttribute('style', 'display: none;');

  return a;
}
